<template>
  <a-layout-footer :style="{ textAlign: 'center' }">
    <div style="padding: 10px 144px;">
      备案号：
      <a href="http://www.beian.miit.gov.cn/" target="_blank">豫ICP备19037402号</a>
    </div>
  </a-layout-footer>
</template>
<script>
export default {
  name: "footer-div"
};
</script>
